{
  "familyId": "MET-SCHAAL-BASIS",
  "questions": [
    {
      "id": "MET-SCHAAL-BASIS-001",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Op een plattegrond staat schaal 1:100. Een kamer is op de tekening 5 cm lang. Hoe lang is de kamer in het echt?",
      "context": null,
      "options": ["5 m", "500 cm", "0,5 m", "50 m"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "mapScale",
          "data": {
            "scaleRatio": 100,
            "unit": "m",
            "label": "Schaal 1 : 100"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "schaal_basis_berekenen",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Stopt na 5 × 100 = 500 zonder cm naar m om te rekenen", "optionIndex": 1 },
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid verwisseld: deelt door 1000 i.p.v. 100", "optionIndex": 2 },
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid vergeten: 500 cm = 5 m, niet 50 m", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1:100 betekent: 1 cm op de tekening = 100 cm in het echt. De kamer is 5 cm op de tekening, dus 5 × 100 = 500 cm. Maar de eenheid is nog cm! Reken om: 500 cm = 5 meter. Onthoud: de schaal werkt in dezelfde eenheid, daarna reken je om naar een handige eenheid.",
        "solutionSteps": [
          "Schaal 1:100 → 1 cm = 100 cm in het echt",
          "5 cm × 100 = 500 cm",
          "Reken om: 500 cm = 5 m",
          "Check: 5 m ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 cm × 100 = 500 cm = 5 meter. Je hebt na de vermenigvuldiging ook nog omgerekend naar meter.",
          "1": "Je rekening klopt (5 × 100 = 500 cm), maar je bent vergeten om te rekenen naar meter. 500 cm = 5 m. Onthoud: na vermenigvuldigen reken je nog om naar een handige eenheid.",
          "2": "Je hebt 500 cm fout omgerekend naar 0,5 m. 500 cm = 5 m (delen door 100, niet door 1000). Onthoud: 100 cm = 1 m.",
          "3": "Je hebt 500 cm fout omgerekend naar 50 m. 500 cm = 5 m (delen door 100, niet door 10). Onthoud: 100 cm = 1 m."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-002",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Een tuin is in het echt 12 meter lang. Op een tekening met schaal 1:200 is de tuin dan:",
      "context": null,
      "options": ["12 cm", "0,6 cm", "6 cm", "24 cm"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "mapScale",
          "data": {
            "scaleRatio": 200,
            "unit": "m",
            "label": "Schaal 1 : 200"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "schaal_echt_naar_tekening",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid vergeten: eerst m → cm omrekenen", "optionIndex": 1 },
          { "id": "met.schaal-richting-omgedraaid", "label": "Schaal verkeerde richting: van echt naar tekening = delen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Van echt naar tekening: deel door het schaalgetal. Eerst omrekenen: 12 m = 1200 cm. Dan delen: 1200 ÷ 200 = 6 cm op de tekening. Onthoud: echt → tekening = delen, en reken altijd eerst om naar cm.",
        "solutionSteps": [
          "Reken om naar cm: 12 m = 1200 cm",
          "Van echt naar tekening: delen door schaalgetal",
          "1200 ÷ 200 = 6 cm",
          "Check: 6 cm op de tekening ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je alleen door 100 moest delen. Maar de schaal is 1:200, niet 1:100. 1200 ÷ 200 = 6 cm. Onthoud: gebruik altijd het juiste schaalgetal.",
          "1": "Je dacht waarschijnlijk dat je 12 m direct door 200 deelt zonder om te rekenen naar cm: 12 ÷ 200 = 0,06 m = 0,6 cm. Maar je moet eerst omrekenen: 12 m = 1200 cm, dan 1200 ÷ 200 = 6 cm.",
          "2": "Goed! 12 m = 1200 cm, gedeeld door 200 = 6 cm.",
          "3": "Je dacht waarschijnlijk dat je 12 × 200 moest doen. Maar van echt naar tekening moet je delen, niet vermenigvuldigen. Onthoud: echt → tekening = delen."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-003",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Wat betekent schaal 1:50?",
      "context": null,
      "options": [
        "1 cm op de tekening = 50 m in het echt",
        "1 cm op de tekening = 50 cm in het echt",
        "50 cm op de tekening = 1 cm in het echt",
        "De tekening is 50 keer groter dan het echt"
      ],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "mapScale",
          "data": {
            "scaleRatio": 50,
            "unit": "m",
            "label": "Schaal 1 : 50"
          }
        }
      ],
      "supportAids": [],
      "conceptId": "schaal_betekenis",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid verward: 1 cm = 50 cm, niet 50 m", "optionIndex": 0 },
          { "id": "met.schaal-richting-omgedraaid", "label": "Schaal verkeerde richting: tekening is kleiner, niet groter", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1:50 betekent: 1 cm op de tekening = 50 cm in het echt. De eenheid blijft hetzelfde. De tekening is 50 keer kleiner dan de werkelijkheid. Onthoud: het eerste getal is de tekening, het tweede is de werkelijkheid.",
        "solutionSteps": [
          "Schaal 1:50 → 1 eenheid op tekening = 50 eenheden in echt",
          "Dus 1 cm = 50 cm in het echt",
          "De tekening is 50× kleiner dan de werkelijkheid",
          "Check: de eenheid verandert niet bij schaal ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de eenheid verandert. Maar bij schaal blijft de eenheid hetzelfde: cm blijft cm. 1 cm = 50 cm, niet 50 m. Onthoud: de eenheid verandert niet bij schaal.",
          "1": "Goed! 1 cm op de tekening = 50 cm in het echt.",
          "2": "Je dacht waarschijnlijk dat het andersom is. Maar 1:50 betekent dat de tekening kleiner is: 1 cm op tekening = 50 cm echt. Onthoud: het eerste getal is de tekening, het tweede is de werkelijkheid.",
          "3": "Je dacht waarschijnlijk dat de tekening groter is. Maar bij schaal 1:50 is de tekening 50 keer kleiner. Onthoud: als het tweede getal groter is, is de tekening kleiner dan het echt."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-004",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een huis met schaal 1:50. De voordeur is in het echt 2 meter hoog. Hoe hoog is de deur op de tekening?",
      "context": null,
      "options": ["40 cm", "2 cm", "10 cm", "4 cm"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 50,
            "realLength": 2,
            "mapLength": 4,
            "unit": "m",
            "label": "Schaal 1 : 50"
          }
        }
      ],
      "conceptId": "schaal_context_architect",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.schaal-richting-omgedraaid", "label": "Schaal verkeerde richting: van echt naar tekening = delen", "optionIndex": 0 },
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid vergeten: eerst m → cm omrekenen", "optionIndex": 1 }
        ]
      },
      "feedback": {
        "explanationText": "2 m = 200 cm. Van echt naar tekening: 200 ÷ 50 = 4 cm. De deur is 4 cm hoog op de tekening. Onthoud: reken altijd eerst om naar centimeter, dan delen door het schaalgetal.",
        "solutionSteps": [
          "Reken om: 2 m = 200 cm",
          "Van echt naar tekening: delen door schaalgetal",
          "200 ÷ 50 = 4 cm",
          "Check: 4 cm op de tekening ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 m × 200 moest doen. Maar van echt naar tekening moet je delen, niet vermenigvuldigen. Onthoud: echt → tekening = delen.",
          "1": "Je dacht waarschijnlijk dat 2 m ÷ 50 = 2 cm. Maar je moet eerst omrekenen naar cm: 2 m = 200 cm. Dan 200 ÷ 50 = 4 cm. Onthoud: reken altijd eerst om naar dezelfde eenheid.",
          "2": "Je dacht waarschijnlijk dat je 200 ÷ 20 moest doen. Maar de schaal is 1:50, dus je deelt door 50. 200 ÷ 50 = 4 cm. Onthoud: gebruik het juiste schaalgetal.",
          "3": "Goed! 200 cm ÷ 50 = 4 cm op de tekening."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-005",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "fill_in",
      "question": "Op een plattegrond met schaal 1:500 is een voetbalveld 20 cm lang. Hoe lang is het veld in het echt? Geef je antwoord in meters.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["100", "100 m", "100 meter"],
        "caseSensitive": false,
        "placeholder": "? meter"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 500,
            "mapLength": 20,
            "realLength": 100,
            "unit": "m",
            "label": "Schaal 1 : 500"
          }
        }
      ],
      "conceptId": "schaal_fill_in",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Van tekening naar echt: vermenigvuldig met het schaalgetal. 20 cm × 500 = 10.000 cm. Reken om naar meter: 10.000 cm ÷ 100 = 100 m. Onthoud: tekening → echt = vermenigvuldigen, en vergeet niet om te rekenen naar de gevraagde eenheid.",
        "solutionSteps": [
          "Van tekening naar echt: vermenigvuldigen",
          "20 cm × 500 = 10.000 cm",
          "10.000 cm ÷ 100 = 100 m",
          "Check: 100 m ✓"
        ]
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-006",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "multiple_choice",
      "question": "Op een kaart met schaal 1 : 25.000 meet je een afstand van 4 cm. Hoe ver is dat in het echt?",
      "context": null,
      "options": ["1 km", "2,5 km", "250 m", "10 km"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 25000,
            "mapLength": 4,
            "realLength": 1,
            "unit": "km",
            "label": "Schaal 1 : 25.000"
          }
        }
      ],
      "conceptId": "schaal_kaart_km",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid vergeten: 100.000 cm = 1 km, niet 2,5 km", "optionIndex": 1 },
          { "id": "met.schaal-eenheid-omrekenen", "label": "Eenheid vergeten: 250 m is maar 1 cm op de kaart", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Schaal 1 : 25.000 betekent: 1 cm op de kaart = 25.000 cm in het echt. 4 cm × 25.000 = 100.000 cm. Reken om: 100.000 cm ÷ 100 = 1.000 m = 1 km.",
        "solutionSteps": [
          "Schaal 1 : 25.000 → 1 cm op kaart = 25.000 cm echt",
          "4 cm × 25.000 = 100.000 cm",
          "100.000 cm ÷ 100 = 1.000 m",
          "Check: 1.000 m = 1 km ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 cm × 25.000 = 100.000 cm = 1.000 m = 1 km.",
          "1": "Je dacht waarschijnlijk dat 1 cm = 250 m, en dan 4 × 250 m = 1.000 m, maar schreef 2,5 km op. 1.000 m = 1 km, niet 2,5 km. Onthoud: reken zorgvuldig om.",
          "2": "Je dacht waarschijnlijk dat 250 m het antwoord is. Maar 250 m is de afstand voor 1 cm op de kaart (25.000 cm = 250 m). Je meet 4 cm, dus 4 × 250 = 1.000 m = 1 km.",
          "3": "Je dacht waarschijnlijk aan schaal 1 : 250.000. Maar de schaal is 1 : 25.000. 4 × 25.000 = 100.000 cm = 1 km, niet 10 km."
        }
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-007",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "fill_in",
      "question": "Een plattegrond heeft schaal 1 : 200. Een kamer is op de plattegrond 3 cm breed. Hoe breed is de kamer in het echt? Geef je antwoord in meter.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "6 m", "6 meter"],
        "caseSensitive": false,
        "placeholder": "? meter"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mapScale",
          "showWhen": "wrong",
          "data": {
            "scaleRatio": 200,
            "mapLength": 3,
            "realLength": 6,
            "unit": "m",
            "label": "Schaal 1 : 200"
          }
        }
      ],
      "conceptId": "schaal_plattegrond_meter",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "Schaal 1 : 200 betekent: 1 cm op de plattegrond = 200 cm in het echt. 3 cm × 200 = 600 cm. Reken om naar meter: 600 cm ÷ 100 = 6 meter.",
        "solutionSteps": [
          "Schaal 1 : 200 → 1 cm op plattegrond = 200 cm echt",
          "3 cm × 200 = 600 cm",
          "600 cm ÷ 100 = 6 meter",
          "Check: 6 meter ✓"
        ]
      }
    },
    {
      "id": "MET-SCHAAL-BASIS-008",
      "familyId": "MET-SCHAAL-BASIS",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schaal",
      "subSkill": "schaal_basis",
      "questionType": "ratio_table",
      "question": "Op een plattegrond met schaal 1 : 100 staat een tafel van 8 cm. Vul de verhoudingstabel aan om de werkelijke lengte te vinden.",
      "options": ["800 cm", "80 cm", "8 m", "8.000 cm"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Plattegrond (cm)", "Werkelijk (cm)"],
        "rows": [[1, 100], [8, null]],
        "hiddenCells": [{ "row": 1, "col": 1 }],
        "missingCell": { "row": 1, "col": 1 },
        "correctValue": 800,
        "hint": "Als 1 cm op de plattegrond = 100 cm echt, dan is 8 cm = 8 × 100 cm."
      },
      "stimulusAids": [{
        "type": "ratio",
        "data": {
          "headers": ["Plattegrond (cm)", "Werkelijk (cm)"],
          "rows": [["1", "100"], ["8", "?"]],
          "label": "Schaal 1 : 100"
        }
      }],
      "supportAids": [{
        "type": "ratio",
        "showWhen": "wrong",
        "data": {
          "headers": ["Plattegrond (cm)", "Werkelijk (cm)"],
          "rows": [["1", "100"], ["8", "800"]],
          "highlight": [1, 1]
        }
      }],
      "conceptId": "schaal_basis_ratio_table",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.schaal-richting-omgedraaid", "label": "Richting omgedraaid (delen i.p.v. ×)", "optionIndex": 1 }
        ]
      },
      "feedback": {
        "explanationText": "De verhoudingstabel toont de relatie: 1 cm op de plattegrond ↔ 100 cm echt. Beide rijen hebben dezelfde verhouding. Vermenigvuldig 8 met 100 → 800 cm. Onthoud: bij schaal 1 : n is werkelijk = plattegrond × n.",
        "solutionSteps": [
          "Lees de schaal: 1 cm op plattegrond = 100 cm echt",
          "Werkelijk = plattegrond × 100",
          "8 × 100 = 800 cm (= 8 m)"
        ]
      }
    }
  ]
}